import React, { useState } from "react";
import { Eye, FileText, CheckCircle, UploadCloud } from "lucide-react";

const investmentOptions = [
  { name: "Loss from Letout Property", section: "LET OUT" },
  { name: "Tax Deducted/Collected at Source", section: "TDS/TCS" },
  { name: "Life Insurance Premium", section: "80C" },
  { name: "Public Provident Fund", section: "80C" },
  { name: "Health Insurance Premium", section: "80D" },
];

export default function TaxProofSubmission() {
  const [selectedComponent, setSelectedComponent] = useState("");
  const [rows, setRows] = useState([]);
  const [lastModified, setLastModified] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [form12BB, setForm12BB] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const empInfo = {
    id: "EMP1024",
    name: "Ravi Kumar",
    pan: "ABCDE1234F",
    year: "2025-2026"
  };

  const handleAddComponent = () => {
    if (!selectedComponent) return;
    const comp = investmentOptions.find(i => i.name === selectedComponent);
    if (!comp || rows.some(r => r.name === comp.name)) return;

    setRows(prev => [
      ...prev,
      {
        name: comp.name,
        section: comp.section,
        declared: "50,000.00",
        proof: "0.00",
        file: null,
      },
    ]);
    setSelectedComponent("");
    if (currentStep < 2) setCurrentStep(2);
  };

  const handleUpload = (index, file) => {
    if (!file) return;
    const updated = [...rows];
    updated[index].file = file;
    setRows(updated);
    setLastModified(new Date().toLocaleString());
  };

  const handleCheckbox = (index) => {
    setSelectedRows(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  // FIXED: Added defensive checks to prevent the "undefined" error
  const handleViewProof = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one checkbox to view proof");
      return;
    }

    let foundFile = false;
    selectedRows.forEach(i => {
      // Check if row exists AND has a file before accessing properties
      if (rows[i] && rows[i].file) {
        foundFile = true;
        const url = URL.createObjectURL(rows[i].file);
        window.open(url, "_blank");
      }
    });

    if (!foundFile) {
      alert("The selected items do not have any uploaded files to view.");
    }
  };

  const handleSubmit = () => {
    if (!rows.some(r => r.file) || !form12BB) {
      alert("Please upload at least one proof and Form 12BB");
      return;
    }
    alert("Tax Proofs submitted successfully!");
    setRows([]);
    setForm12BB(null);
    setSelectedRows([]);
    setCurrentStep(1);
  };

  return (
    <div className="min-h-screen bg-[#F0F2F5] p-6 font-['Roboto',sans-serif] text-[13px] text-gray-700">
      
      {/* ERP HEADER PANEL */}
      <div className="bg-white border border-gray-200 rounded shadow-sm mb-6">
        <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 font-bold text-gray-600 flex justify-between">
          <span>Employee Tax Proof Submission Details</span>
          <span className="text-blue-600 uppercase text-[10px]">Financial Year: {empInfo.year}</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 p-4">
          <div>
            <p className="text-gray-400 text-[11px] uppercase font-bold">Employee ID</p>
            <p className="font-semibold text-gray-900">{empInfo.id}</p>
          </div>
          <div>
            <p className="text-gray-400 text-[11px] uppercase font-bold">Employee Name</p>
            <p className="font-semibold text-gray-900">{empInfo.name}</p>
          </div>
          <div>
            <p className="text-gray-400 text-[11px] uppercase font-bold">PAN Number</p>
            <p className="font-semibold text-gray-900">{empInfo.pan}</p>
          </div>
          <div>
            <p className="text-gray-400 text-[11px] uppercase font-bold">Status</p>
            <p className="font-semibold text-orange-600 flex items-center gap-1">
               <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></span>
               Pending Submission
            </p>
          </div>
        </div>
      </div>

      {/* ALERT BOX */}
      <div className="bg-[#FFFBE6] border border-[#FFE58F] p-3 rounded mb-6 flex items-center gap-3">
        <span className="text-orange-500 text-lg font-bold">⚠️</span>
        <p className="text-[#856404] font-medium text-xs">
          Tax Investment Proofs will not be considered valid unless the **Form 12BB** is uploaded and signed.
        </p>
      </div>

      {/* ACTION BAR */}
      <div className="flex flex-wrap justify-between items-end gap-4 mb-4">
        <div className="flex-1 max-w-md">
          <label className="block text-[11px] font-bold text-gray-500 mb-1 uppercase tracking-wider">Select Investment Component</label>
          <div className="flex gap-2">
            <select
              className="flex-1 border border-gray-300 px-3 py-2 bg-white outline-none focus:border-blue-500 rounded-sm"
              value={selectedComponent}
              onChange={e => setSelectedComponent(e.target.value)}
            >
              <option value="">-- Click to add new item --</option>
              {investmentOptions.map(o => (
                <option key={o.name} value={o.name}>{o.name} ({o.section})</option>
              ))}
            </select>
            <button onClick={handleAddComponent} className="bg-blue-700 text-white px-6 py-2 font-bold hover:bg-blue-800 transition rounded-sm shadow-sm">
              ADD ITEM
            </button>
          </div>
        </div>

        <div className="flex gap-2">
          <button onClick={handleViewProof} className="bg-white border border-gray-300 text-gray-700 px-4 py-2 font-bold hover:bg-gray-50 flex items-center gap-2 rounded-sm shadow-sm">
            <Eye size={16} className="text-gray-500" /> VIEW PROOF
          </button>
          
          {rows.some(r => r.file) && currentStep < 3 && (
            <button onClick={() => setCurrentStep(3)} className="bg-indigo-600 text-white px-4 py-2 font-bold hover:bg-indigo-700 flex items-center gap-2 rounded-sm shadow-sm transition-all animate-in slide-in-from-right-2">
              PROCEED TO 12BB <FileText size={16} />
            </button>
          )}
        </div>
      </div>

      {/* TABULAR ERP FORM */}
      <div className="bg-white border border-gray-200 rounded shadow-sm overflow-hidden mb-6">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-50 text-gray-500 text-[11px] uppercase tracking-wider font-bold text-left">
              <th className="border-b p-4 text-center w-12">#</th>
              <th className="border-b p-4">Investment Description</th>
              <th className="border-b p-4 text-center">IT Section</th>
              <th className="border-b p-4 text-right">Declared (₹)</th>
              <th className="border-b p-4 text-right">Proof Amt (₹)</th>
              <th className="border-b p-4 text-center">Upload Proof</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.length === 0 ? (
              <tr>
                <td colSpan="6" className="p-16 text-center text-gray-400 italic bg-gray-50/50">
                  <UploadCloud size={32} className="mx-auto mb-2 opacity-20" />
                  No investment components added yet.
                </td>
              </tr>
            ) : (
              rows.map((r, i) => (
                <tr key={i} className={`hover:bg-blue-50/20 transition-colors ${r.file ? 'bg-green-50/20' : ''}`}>
                  <td className="p-4 text-center">
                    <input 
                      type="checkbox" 
                      checked={selectedRows.includes(i)} 
                      onChange={() => handleCheckbox(i)} 
                      className="w-4 h-4 rounded border-gray-300 accent-blue-600 cursor-pointer" 
                    />
                  </td>
                  <td className="p-4 font-semibold text-gray-800">{r.name}</td>
                  <td className="p-4 text-center">
                    <span className="bg-gray-100 px-2 py-1 rounded text-[10px] font-bold text-gray-500 border border-gray-200">
                      {r.section}
                    </span>
                  </td>
                  <td className="p-4 text-right font-mono text-gray-500">{r.declared}</td>
                  <td className="p-4 text-right font-mono font-bold text-blue-700">
                    {r.file ? r.declared : "0.00"}
                  </td>
                  <td className="p-4">
                    <div className="flex items-center justify-center gap-2">
                      <label className={`flex items-center gap-2 px-3 py-1.5 rounded-sm cursor-pointer border font-bold text-[10px] transition-all shadow-sm
                        ${r.file 
                          ? "bg-green-600 text-white border-green-700" 
                          : "bg-white border-blue-600 text-blue-600 hover:bg-blue-50"}`}>
                        <UploadCloud size={14} />
                        {r.file ? "RE-UPLOAD" : "SELECT FILE"}
                        <input type="file" className="hidden" onChange={e => handleUpload(i, e.target.files[0])} />
                      </label>
                      {r.file && (
                        <div className="flex items-center text-green-600 gap-1 animate-in zoom-in" title={r.file.name}>
                           <CheckCircle size={14} />
                           <span className="text-[9px] truncate max-w-[60px] uppercase font-bold">Attached</span>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="bg-gray-50 p-3 text-[10px] text-gray-400 border-t flex justify-between">
          <span>* Only PDF, JPG, and PNG files are accepted.</span>
          <span>Last modified: {lastModified || "Never"}</span>
        </div>
      </div>

      {/* STEP 3: FORM 12BB PANEL */}
      {currentStep >= 3 && (
        <div className="bg-indigo-50 border border-indigo-200 rounded p-6 mb-6 shadow-sm flex flex-col md:flex-row items-center justify-between gap-4 animate-in fade-in slide-in-from-bottom-4">
            <div className="flex items-center gap-4">
               <div className="bg-indigo-600 p-3 rounded-lg text-white">
                  <FileText size={24} />
               </div>
               <div>
                  <h3 className="text-indigo-900 font-bold text-base uppercase tracking-tight">Required: Signed Form 12BB</h3>
                  <p className="text-indigo-700 text-xs">Download, sign, and upload the Form 12BB declaration to finalize submission.</p>
               </div>
            </div>
            <label className="bg-indigo-600 text-white px-8 py-3 rounded-sm font-bold cursor-pointer hover:bg-indigo-700 transition shadow-md whitespace-nowrap">
              {form12BB ? `✓ ${form12BB.name}` : "UPLOAD FORM 12BB"}
              <input type="file" className="hidden" onChange={e => {
                setForm12BB(e.target.files[0]);
                setCurrentStep(4);
              }} />
            </label>
        </div>
      )}

      {/* FINAL SUBMIT ACTION */}
      {currentStep === 4 && (
        <div className="flex justify-end pt-6 border-t border-gray-200 mt-8">
          <div className="text-right">
             <p className="text-[10px] text-gray-400 mb-2 italic">By clicking submit, I certify that all uploaded documents are authentic.</p>
             <button onClick={handleSubmit} className="bg-green-600 text-white px-12 py-4 rounded-sm font-bold text-sm shadow-xl hover:bg-green-700 transition-all tracking-[2px] uppercase active:scale-95">
               Final Submission
             </button>
          </div>
        </div>
      )}
    </div>
  );
}